// Custom centered confirm modal, used in place of the native browser confirm()
// so it can be styled. Bound once at load time (not per Turbolinks visit) and
// looks up the modal fresh on every interaction, since Turbolinks replaces the
// document body (and its contents) on each visit.

var pendingForm = null

function findModalParts() {
  var modal = document.getElementById('pj-confirm-modal')
  if (!modal) return null

  return {
    modal: modal,
    icon: modal.querySelector('.pj-modal-icon'),
    title: modal.querySelector('.pj-modal-title'),
    text: modal.querySelector('.pj-modal-text'),
    confirmBtn: modal.querySelector('.pj-modal-confirm')
  }
}

function openModal(trigger) {
  var parts = findModalParts()
  if (!parts) return

  parts.icon.hidden = !trigger.hasAttribute('data-modal-icon')
  parts.title.textContent = trigger.getAttribute('data-modal-title') || 'Are you sure?'
  parts.text.textContent = trigger.getAttribute('data-modal-text') || ''
  parts.confirmBtn.textContent = trigger.getAttribute('data-modal-confirm-label') || 'Confirm'
  pendingForm = trigger.closest('form')
  parts.modal.hidden = false
  parts.confirmBtn.focus()
}

function closeModal() {
  var parts = findModalParts()
  if (parts) parts.modal.hidden = true
  pendingForm = null
}

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-confirm-modal]')
  if (trigger) {
    event.preventDefault()
    event.stopPropagation()
    openModal(trigger)
    return
  }

  if (event.target.closest('.pj-modal-confirm')) {
    var form = pendingForm
    closeModal()
    if (form) form.submit()
    return
  }

  if (event.target.closest('.pj-modal-cancel')) {
    closeModal()
    return
  }

  if (event.target.id === 'pj-confirm-modal') {
    closeModal()
  }
}, true)

document.addEventListener('keydown', function (event) {
  var parts = findModalParts()
  if (event.key === 'Escape' && parts && !parts.modal.hidden) closeModal()
})
